import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import { Alert, Input, Pill, styled, Text } from '@/theme/index';

const PasswordSection = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  paddingTop: theme.spacing(8),
  background: `${
    theme.palette.accountInfoModals?.dark || theme.palette.grey[300]
  }`,
  position: 'relative',
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(2.5),
  borderRadius: '4px',
}));

export function CurrentPasswordSection() {
  const { register } = useFormContext();
  return (
    <PasswordSection>
      <Pill
        sx={{ position: 'absolute', left: 0, top: '20px' }}
        label="For your security"
        className="left-tag"
        color="info"
      />
      <Text variant="body2" sx={{ marginBottom: '20px' }}>
        Enter Your Password so we can verify that you are the account owner
      </Text>
      <Input
        {...register('password')}
        fullWidth
        id="password"
        type="password"
        name="password"
        placeholder="Current password"
        inputProps={{ 'data-cy': 'edit_password_modal' }}
      />
    </PasswordSection>
  );
}

export function PasswordError({
  showCurrentPasswordError,
  message,
}: {
  showCurrentPasswordError: boolean;
  message: string | undefined;
}): ReactElement | null {
  if (showCurrentPasswordError) {
    return (
      <Alert
        severity="error"
        sx={{ marginBottom: '20px', width: '100%' }}
        variant="filled"
      >
        {message}
      </Alert>
    );
  }
  return null;
}

export interface ErrorObject {
  error?: string;
  message?: string;
}
